import { axios } from '@ben/api/axios';
import type { AxiosRequestConfig } from 'axios';
import type { BenefitDocument } from '@ben/api/gen/codegen.schemas';

export const uploadBenefitDocuments = async (
  data: unknown,
  options?: AxiosRequestConfig<unknown>
): Promise<BenefitDocument> => {
  const response = await axios.post<BenefitDocument>(
    `benefit-documents/`,
    data,
    options
  );
  return response.data;
};
